import './input_container.less';

import React, { Component } from 'react';
import autobind from 'class-autobind';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from './tooltip.jsx';

import TextInput from 'zoomforth_component_lib/basic_text_input.jsx';


class InputContainer extends Component {

  constructor(props) {
    super(props);
    autobind(this);
  }

  focus() {
    if (this.inputRef) {
      this.inputRef.focus();
    }
  }

  onInputRefReceived(inputRef) {
    const { tellRef } = this.props;

    this.inputRef = inputRef;

    // Note that this tellRef might be overriden
    if (tellRef) {
      tellRef(inputRef);
    }
  }

  render() {

    const { 
      className,
      style,
      dark,
      inputStyle,
      error,
      success,
      halfsie,
      isAllowedEmpty,
      tooltip,
      tooltipGravity,
      tooltipPlacement,
      children,
      descriptionText,
      extra,
      ...inputProps
    } = this.props;

    return (
      <div style={style}
        className={classNames('input-container', className, {
          error: error,
          success: success,
          halfsie: halfsie,
          dark: dark
        })}
      >

        {
          !(this.props.name || tooltip) ? null :
          <div className="field-name-container">
            <span className="field-name">{this.props.name}</span>
            { 
              tooltip && 
              <Tooltip
                value={tooltip}
                gravity={tooltipGravity}
                placement={tooltipPlacement}
              />
            }
          </div>
        }
        <div className="form-elements-container">
          {
            children ? 
              children 

            : isAllowedEmpty ?
              null
            :
              <TextInput 
                style={inputStyle}
                tellRef={this.onInputRefReceived}
                {...inputProps}
              />
          }
        </div>

        {
          descriptionText &&
          <div className="description-container">
            { descriptionText }
          </div>
        }

        {
          error &&
          <div className="error-message-container">
            { error }
          </div>
        }
        
        {
          success &&
          <div className="success-message-container">
            { success }
          </div>
        }

        {extra}
      </div>
    );

  }
}


InputContainer.propTypes = {
  name: PropTypes.node,
  // The error message to display
  error: PropTypes.string,
  // The text or HTML to show in a tooltip
  tooltip: PropTypes.node,
  tooltipGravity: PropTypes.string,
  // The explaining text or HTML to show below the input container
  descriptionText: PropTypes.node,
  focusOnMount: PropTypes.bool,
  extra: PropTypes.node
};

InputContainer.defaultProps = {
  tooltipGravity: 'n',
  focusOnMount: false,
  isAllowedEmpty: false
};

export default InputContainer;
